"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KicadFileType = void 0;
var KicadFileType;
(function (KicadFileType) {
    KicadFileType["EESchemaBrd"] = ".brd";
    KicadFileType["KicadPcb"] = ".kicad_pcb";
    KicadFileType["KicadSch"] = ".kicad_sch";
    KicadFileType["EESchemaSch"] = ".sch";
    KicadFileType["EESchemaLib"] = ".lib";
    KicadFileType["KicadFootprintLibTable"] = "fp-lib-table";
    KicadFileType["KicadSymbolLibTable"] = "sym-lib-table";
    KicadFileType["KicadDocLib"] = ".dcm";
    KicadFileType["KicadProject"] = ".kicad_pro";
    KicadFileType["KicadProjectLocalSettings"] = ".kicad_prl";
    KicadFileType["KicadSymbol"] = ".kicad_sym";
    KicadFileType["KicadModule"] = ".kicad_mod";
    KicadFileType["KicadNetlist"] = ".net";
})(KicadFileType || (exports.KicadFileType = KicadFileType = {}));
//# sourceMappingURL=kicad-file-type.js.map